<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Personel</label>
            <v-select-list v-model="employee" v-on:input="getJobNotices" :options="employees" v-on:search="searchEmployees" label="Combine" placeholder="Personel" :loading="employeeLoading"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">SGK Çalışma Kaydı</label>
            <v-select-list :disabled="(jobNotices || []).lenght == 0 || !employee" v-model="jobNotice" :options="jobNotices" label="Name" placeholder="SGK Çalışma Kaydı" :loading="jobNoticeLoading"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Tutar (TL)</label>
            <v-currency-input input-class="text-right" :value="value.Amount" v-on:update-value="currencyAmount => value.Amount = currencyAmount"></v-currency-input>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'

export default {
    components:{
        VCurrencyInput
    },
    props:{
        filter:{
            type:Object,
            default:() => ({})
        },
        value:Object
    },
    data(){
        return {
            employeeLoading:false,
            employees:[],
            jobNotices:[],
            jobNoticeLoading:false
        }
    },
    methods:{
        searchEmployees(searchKey){
            if(searchKey){
                const search = () => {
                    this.employeeLoading = true
                    clearTimeout(this.searchOnTableTimer)
                    this.searchOnTableTimer = setTimeout(()=>{ 
                        this.employeeLoading = true
                        EmployeeOperationsApi.EmployeeExceptionalKYKMCalculationStatusEmployees({
                            PaginateRequest:{
                                QueryParam:searchKey,
                            },
                            ...this.filter
                        }).then((res) => {
                            this.employeeLoading = false
                            this.employees = res.data?.map(d=>({
                                ...d,
                                Id:d.Key,
                                Combine:d.Value
                                //Combine:[d.IdentityNumber,d.FullName].join(' - ')
                            })) || []
                        }).catch(err=> {
                            console.log(err)
                            this.employeeLoading = false
                        })
                    },500)
                }
                clearTimeout(this.searchOnTableTimer)
                this.searchOnTableTimer = setTimeout(()=>{ search.call(this) },500)
            }
        },
        getJobNotices(){
            this.jobNotices = []
            this.value.SGKJobNoticeId = null
            if(this.value.EmployeeId){
                this.jobNoticeLoading = true
                EmployeeOperationsApi.EmployeeExceptionalKYKMCalculationStatusSGKJobNotices({
                    ...this.filter,
                    EmployeeId:this.value.EmployeeId
                }).then(res => {
                    this.jobNoticeLoading = false
                    this.jobNotices = res.data?.map(d => ({
                        ...d,
                        Id:d.Key,
                        Name:d.Value
                    }))
                }).catch(err => {
                    this.jobNoticeLoading = false
                })
            }
        }
    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        jobNotice:{
            get:function(){
                return this.jobNotices.find(s=>s.Id==this.value.SGKJobNoticeId)
            },
            set:function(value){
                this.value.SGKJobNoticeId = value?.Id || null
            }
        },
    }
}
</script>